import { NgSelectExtensionDirective } from '@shared/directives/ng-select-extension.directive';
import { TASK_SIDENAV_FORM } from '@shared/modules/task-sidenav/const/task-sidenav-form';
import { Subscription } from 'rxjs';
import { ETaskGroup, ETaskTypeGroup } from '@shared/modules/task-sidenav/enums/task-group.enum';
import { Config } from '@shared/configs/config';
import { TaskSidenavService } from '@shared/modules/task-sidenav/services/task-sidenav.service';
import {
  Component,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { debounceTime, tap, distinctUntilChanged } from 'rxjs/operators';
import { EmployeeSearchComponent } from '@shared/components/employee-search/employee-search.component';
import { TaskType } from '@shared/enums/task-type.enum';

@Component({
  selector: 'task-sidenav-blue-create',
  templateUrl: './task-sidenav-blue-create.component.html',
  styleUrls: ['./task-sidenav-blue-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskSidenavBlueCreateComponent implements AfterViewInit, OnDestroy {
  CONFIG = Config;
  initial: boolean = false;
  sub: Subscription;
  projectSub: Subscription;
  @ViewChild('search') search: EmployeeSearchComponent;
  @ViewChild(NgSelectExtensionDirective) taskGroup: NgSelectExtensionDirective;
  @ViewChild('tagsSelect') tagsSelect: NgSelectExtensionDirective;

  get taskGroupURL() {
    const control = this.service.form.get(this.service.TASK_SIDENAV_FORM.projectId);
    return Config.API + '/task-group' + (control?.value ? `?projectId=${control?.value}` : '');
  }

  get isTaskChange(): boolean {
    const type = this.service.task?.type || this.service.form.get(TASK_SIDENAV_FORM.type).value;
    return type === TaskType.TYPE_CHANGE;
  }

  get isProcessTaskContext(): boolean {
    return (
      !!this.service?.isProcessTaskContext ||
      this.service?.groupType === 'activity-template' ||
      !!this.service?.activityTemplateContext
    );
  }

  get shouldHideProcessEditMetaFields(): boolean {
    return this.service.isEdit && this.isProcessTaskContext;
  }

  constructor(
    public service: TaskSidenavService,
    private changes: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.sub = new Subscription();
    this.listenProjectChange();
    this.service.registerSearchEmployee(this.search);
    this.service.registerGroupRef(this.taskGroup);
    const subChanges = this.service.taskActionEmitter.subscribe(() => this.changes.detectChanges());
    this.sub.add(subChanges);
  }

  listenProjectChange() {
    this.projectSub = this.service.form
      .get(TASK_SIDENAV_FORM.projectId)
      .valueChanges.pipe(
        distinctUntilChanged(),
        tap(() => {
          this.initial = false;
          this.service.defaultGroupID = null;
          this.changes.detectChanges();
        })
      )
      .pipe(
        debounceTime(0),
        tap(() => {
          this.taskGroup?.getItems();
          this.tagsSelect?.getItems();
        })
      )
      .subscribe();
  }

  taskGroupTransform(list) {
    if (!this.initial && !this.service.defaultGroupID) {
      const found =
        list.filter((i) => i.name === ETaskGroup.ALL_TASKS || i.name === ETaskTypeGroup.GROUP_TASK)[0]?.id ||
        null;
      this.service.defaultGroupID = found;
      this.service.form
        .get(this.service.TASK_SIDENAV_FORM.groupId)
        .patchValue(this.service.defaultGroupID, { onlySelf: true });
      this.initial = true;
    }

    return list?.filter((i) => i.name !== ETaskTypeGroup.GROUP_CHANGE);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.projectSub?.unsubscribe();
  }
}
